import React from 'react';
import PropTypes from 'prop-types';

import { CurrencyFormatter, Row, Text } from '../../../../../common';

const Info = props => {
  const { product } = props;
  const { info, price } = product;

  return (
    <div style={{ marginBottom: 50 }}>
      <div style={{ marginBottom: 20 }}>
        <Text h1 white upper>{info.title}</Text>
      </div>
      {/*<div style={{ marginBottom: 20 }}>*/}
      {/*  <Text h3 white newLine>{info.description}</Text>*/}
      {/*</div>*/}
      <div>
        <Text h2 white bold newLine>
          <CurrencyFormatter amount={price.currentUah} curr="UAH" />
        </Text>
      </div>
      {price.previousUah && (
        <Row>
          <Text h4 ghost italic newLine lineThrough>
            <CurrencyFormatter amount={price.previousUah} curr="UAH" />
          </Text>
        </Row>
      )}
    </div>
  );
};

Info.propTypes = {
  product: PropTypes.object.isRequired
};

export default Info;